module.exports = __webpack_public_path__ + "img/web_neipu_2.5692ba74.jpg";